import { ApiRoutes } from "@/lib/routes";

import BrowseControlsStore from "@/areas/compliance/stores/BrowseControlsStore";
import BrowseControlsSummaryStore from "@/areas/compliance/stores/BrowseControlsSummaryStore";
import BrowseDomainsStore from "@/areas/compliance/stores/BrowseDomainsStore";
import BrowseTargetsStore from "@/areas/compliance/stores/BrowseTargetsStore";
import BrowseDeploymentsStore from "@/areas/compliance/stores/BrowseDeploymentsStore";
import CreateControlStore from "@/areas/compliance/stores/CreateControlStore";
import CreateDomainStore from "@/areas/compliance/stores/CreateDomainStore";
import CreateTargetStore from "@/areas/compliance/stores/CreateTargetStore";
import BrowseActivitiesStore from "@/areas/compliance/stores/BrowseActivitiesStore";
import BrowseTargetRolesStore from "@/areas/subscriptions/stores/BrowseTargetRolesStore";
import BrowseTargetFieldsStore from "@/areas/fields/stores/BrowseTargetFieldsStore";
import BrowseDeploymentTargetsStore from "@/areas/compliance/stores/BrowseDeploymentTargetsStore";
import CreateDeploymentTargetStore from "@/areas/compliance/stores/CreateDeploymentTargetStore";
import BrowseActivitiesSummaryStore from "@/areas/compliance/stores/BrowseActivitiesSummaryStore";
import SelectedActivitySetStore from "@/areas/compliance/stores/SelectedActivitySetStore";
import RequirementHistoryStore from "@/areas/compliance/stores/RequirementHistoryStore";
import BrowseControlWatchlistStore from "@/areas/compliance/stores/BrowseControlWatchlistStore";
import BrowseImplementationGroupsStore from "@/areas/compliance/stores/BrowseImplementationGroupsStore";
import CreateImplementationGroupStore from "@/areas/compliance/stores/CreateImplementationGroupStore";

import BrowseControlActivitiesSummaryStore from "@/areas/compliance/stores/BrowseControlActivitiesSummaryStore";
import ComplianceConfigurationStore from "@/areas/compliance/stores/ComplianceConfigurationStore";
import SegregationOfDutiesStore from "@/areas/compliance/stores/SegregationOfDutiesStore";

import ExportControlsStore from "@/areas/compliance/stores/ExportControlsStore";
import ExportActivitiesStore from "@/areas/compliance/stores/ExportActivitiesStore";
import ExportDomainsStore from "@/areas/compliance/stores/ExportDomainsStore";

import BrowseAuditsStore from "@/areas/compliance/stores/BrowseAuditsStore";
import CreateAuditStore from "@/areas/compliance/stores/CreateAuditStore";
import AuditActivitiesStore from "@/areas/compliance/stores/AuditActivitiesStore";
import AuditMaturitiesStore from "@/areas/compliance/stores/AuditMaturitiesStore";

export default class ComplianceRootStore {
  constructor(parentStore) {
    this.parentStore = parentStore;

    this.browseControlsStore = new BrowseControlsStore(this);
    this.browseDomainsStore = new BrowseDomainsStore(this);
    this.browseTargetsStore = new BrowseTargetsStore(this);
    this.browseDeploymentsStore = new BrowseDeploymentsStore(this);
    this.createDomainStore = new CreateDomainStore(this);
    this.createControlStore = new CreateControlStore(this);
    this.createTargetStore = new CreateTargetStore(this);
    this.exportControlsStore = new ExportControlsStore(this);
    this.exportActivitiesStore = new ExportActivitiesStore(this);
    this.exportDomainsStore = new ExportDomainsStore(this);

    this.browseActivitiesStore = new BrowseActivitiesStore(this);
    this.browseControlsSummaryStore = new BrowseControlsSummaryStore(this);
    this.browseActivitiesSummaryStore = new BrowseActivitiesSummaryStore(this);
    this.browseControlWatchlistStore = new BrowseControlWatchlistStore(this);
    this.browseControlActivitiesSummaryStore = new BrowseControlActivitiesSummaryStore(this);

    this.browseRolesStore = new BrowseTargetRolesStore(this, ApiRoutes.forComplianceRoles("control"));
    this.browseRegistryRolesStore = new BrowseTargetRolesStore(this, ApiRoutes.forComplianceRoles("registry"));
    this.browseActivityRolesStore = new BrowseTargetRolesStore(this, ApiRoutes.forComplianceRoles("activity"));
    this.browseAuditRolesStore = new BrowseTargetRolesStore(this, ApiRoutes.forComplianceRoles("audit"));
    this.browseAuditRegistryRolesStore = new BrowseTargetRolesStore(
      this,
      ApiRoutes.forComplianceRoles("audit-registry")
    );

    this.browseFieldsStore = new BrowseTargetFieldsStore(this, ApiRoutes.forComplianceFields());

    this.browseDeploymentTargetsStore = new BrowseDeploymentTargetsStore(this);
    this.createDeploymentTargetStore = new CreateDeploymentTargetStore(this);

    this.selectedActivitySetStore = new SelectedActivitySetStore(this);
    this.requirementHistoryStore = new RequirementHistoryStore(this);

    this.browseImplementationGroupsStore = new BrowseImplementationGroupsStore(this);
    this.createImplementationGroupStore = new CreateImplementationGroupStore(this);

    this.browseAuditsStore = new BrowseAuditsStore(this);
    this.createAuditStore = new CreateAuditStore(this);

    this.auditMaturitiesStore = new AuditMaturitiesStore(this);

    this.configurationStore = new ComplianceConfigurationStore(this);
    this.segregationOfDutiesStore = new SegregationOfDutiesStore(this);
  }
}
